export default __webpack_public_path__ + "static/media/iconcheck.5840c26a.svg";